"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function updateProficiency(aggregatedStat, sessionEvent) {
    return sessionEvent.session.endingProficiency;
}
exports.default = updateProficiency;
